import React, {
  useContext,
} from 'react';
import {
  ThemeContext,
} from 'styled-components';

import {
  Icon,
} from 'web-components';

import {
  SVG,
} from 'web-styled';

import * as S from '../styled';

const sidebarIcons = {
  dashboard: SVG.Home,
  billing: SVG.Billing,
  clients: SVG.Clients,
  individuals: SVG.Client,
  groups: SVG.Group,
  calendar: SVG.Calendar,
  exercises: SVG.Exercise,
  workout2: SVG.KettleBell,
  programs: SVG.Program,
  warmups: SVG.Warmup,
  cooldowns: SVG.Cooldown,
  videogallery: SVG.VideoLibrary,
  trainings: SVG.Trainings,
  properties: SVG.Metrics,
  marketplace: SVG.Transaction,
  documents: SVG.Document,
  messages: SVG.Messages,
};

type Props = {
  icon: string,
  level: number,
  isFolder: boolean,
  selected: boolean,
};

const ItemIcon = ({
  icon,
  level,
  isFolder,
  selected,
}: Props) => {
  const theme = useContext(ThemeContext);
  const Component = sidebarIcons[icon];
  return (Component && (level === 0 || !isFolder)) ? (
    <S.SVGIcon>
      <Component
        fill={selected ? theme.colors.sidebarLink : '#fff'}
        stroke={selected ? theme.colors.sidebarLink : '#fff'}
      />
    </S.SVGIcon>
  ) : (
    <Icon
      type="far fa-folder"
      size="13px"
    />
  );
};

export default ItemIcon;
